import { createContext, useContext, ReactNode, ReactElement } from "react";

import type { AxiosInstance } from "axios";

interface ApiContextValue {
  axiosInstance: AxiosInstance;
}

const ApiContext = createContext<ApiContextValue | null>(null);

interface ApiProviderProps {
  children: ReactNode;
  axiosInstance: AxiosInstance;
}

export function ApiProvider({
  children,
  axiosInstance,
}: ApiProviderProps): ReactElement {
  return (
    <ApiContext.Provider value={{ axiosInstance }}>
      {children}
    </ApiContext.Provider>
  );
}

export function useApi(): AxiosInstance {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error("useApi must be used within an ApiProvider");
  }
  return context.axiosInstance;
}
